module.exports = __webpack_public_path__ + "static/media/2_CN.a36fc63c.PNG";